import { Currency } from '@/core/currency/interfaces';

const ISK: Currency = {
    name: 'Icelandic Krona',
    demonym: 'Icelandic',
    majorSingle: 'Krona',
    majorPlural: 'Krónur',
    codeNumeric: '352',
    symbol: 'kr',
    symbolNative: 'kr',
    minorSingle: 'Aurar',
    minorPlural: 'Aurar',
    ISOdigits: 0,
    decimals: 2,
    numToBasic: 100,
    code: 'ISK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default ISK;
